import { BalanceTypes } from "@redotech/redo-billing-common/balance/balances";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getBalance = {
  name: "getBalance" as const,
  input: z.object({ account: createEnum(BalanceTypes), teamId: z.string() }),
  output: z.object({ balance: z.string().nullish() }),
};
